import React from 'react'
import servingLogo from 'images/Servings_gray.svg'
import timeLogo from 'images/Time_gray.svg'
import expandLogo from 'images/expand.svg'

import './LoadingPanel.scss'

export const LoadingPanel = () => {
  const smallCard = (
    <>
      <div className="expand-logo">
        <img src={expandLogo} alt="expand-logo" />
      </div>
      <div className="small-content">
        <h2 className="content-title ">
          <div
            className="gradientBox"
            style={{
              marginTop: '15px',
            }}
          />
          <div
            className="gradientBox"
            style={{
              width: '100px',
              marginTop: '5px',
            }}
          />
        </h2>
        <div className="content-body">
          <div className="text">
            <img src={servingLogo} alt="serving" />
            <span className="bodytext">
              <div className="gradientBox" style={{ width: '80px' }} />
            </span>
          </div>
          <div className="text">
            <img style={{ padding: '0px 2px' }} src={timeLogo} alt="time" />
            <span className="bodytext">
              <div className="gradientBox" style={{ width: '80px' }} />
            </span>
          </div>
        </div>
        <div className="see-recipe"></div>
      </div>
    </>
  )

  return <div className={'LoadingPanel-recipe '}>{smallCard}</div>
}

export default LoadingPanel
